export default "__VITE_ASSET__Csq$qxY7__"